import { Input, Component } from '@angular/core';

import { Location } from '@shared/location/models';
import { SubscriptionTypes } from '@shared/restaurant/enums';

const MAX_PAGE_SIZE = 4;

@Component({
  selector: 'tablesready-billing-offline-locations',
  templateUrl: './offline-locations.component.html',
  styleUrls: ['./offline-locations.component.scss'],
})
export class OfflineLocationsComponent {
  @Input() locations: Location[];
  @Input() accountSubscriptionType: SubscriptionTypes;

  locationPageIndex = 0;
  locationPageSize = MAX_PAGE_SIZE;
  maxDisplayPages = MAX_PAGE_SIZE;

  get start(): number {
    return (this.locationPageIndex - 1) * this.locationPageSize;
  }

  get end(): number {
    return (this.locationPageIndex - 1) * this.locationPageSize + this.locationPageSize
  }
}
